function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import { UnstyledControlledSelect } from "../../unstyled/select/UnstyledControlledSelect";
import "./select.css";
/*
 Returns a controlled select component.
 
  Props:
   - classPrepend: (string) CSS class name prefix to apply custom styling.
   - options: (array) An array of options for the select.
   - name: (string) The name attribute of the select.
   - placeholder: (string, optional) The placeholder text to display when no option is selected.
   - helperText: (string) Additional helper text to display.
   - label: (string, optional) The label for the select.
   - value: (string) The current value of the select. if there is no initial value the value needs to be null
   - onChange: (function) The function to call when the select value changes.
 */

const ControlledSelect = ({
  classPrepend = 'styled',
  options,
  name = "",
  placeholder = "",
  helperText = "",
  required = false,
  label = "",
  value = null,
  onChange = null,
  toggleIcon = /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faAngleDown
  }),
  showToggleIcon = true,
  ...rest
}) => {
  return /*#__PURE__*/React.createElement(UnstyledControlledSelect, _extends({
    classPrepend: classPrepend,
    options: options,
    name: name,
    placeholder: placeholder,
    helperText: helperText,
    required: required,
    label: label,
    value: value,
    onChange: onChange,
    toggleIcon: toggleIcon,
    showToggleIcon: showToggleIcon
  }, rest));
};
export { ControlledSelect };